import type {Pointer} from '@wix/document-services-types'
import {VariableRepository} from './repository'
import {type IVariablesService, VariablesService} from './service'
import {VariableStyleTransformer} from './style-transformer'
import {VariableDefaultsExtractor} from './defaults-extractor'
import type {VariantsAPI} from '../../variants/variants'

export class VariablesServiceFactory {
    static createVariablesService(variantsAPI: VariantsAPI, rootWidget: Pointer): IVariablesService {
        const dataRepository = new VariableRepository(variantsAPI, rootWidget)
        const variableStyleTransformer = new VariableStyleTransformer()
        const variableDefaultsExtractor = new VariableDefaultsExtractor()

        return new VariablesService(dataRepository, variableStyleTransformer, variableDefaultsExtractor)
    }
}
